module.exports = __webpack_public_path__ + "static/media/olimpicgames.360417a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/olimpicgames.svg
// module id = 389
// module chunks = 7